import { useCallback } from 'react'
import shallow from 'zustand/shallow'
import useFilterStore from '../../../filters'

/**
 * Returns a handler function that sets `neq` filters for
 * flags based on the provided collection of flags and the
 * value passed to the handler.  Provides handlers
 * to the filter button groups (SedaAgeGroup, SedaSchoolType, etc.)
 */
export default function useToggleFlagsHandler(flags) {
  const [removeFilter, setFilter] = useFilterStore(
    state => [state.removeFilter, state.setFilter],
    shallow
  )

  return useCallback(
    newValue => {
      // remove all flag filters if the new value is empty
      if (!newValue?.length || newValue?.includes('all'))
        return flags.forEach(flag =>
          removeFilter(['neq', flag], true)
        )
      // remove any `neq` filters that are included in the new value
      newValue.forEach(flag => removeFilter(['neq', flag], true))
      // add any `neq` filters required based on the
      const inverse = flags.filter(f => !newValue.includes(f))
      inverse.forEach(flag => setFilter(['neq', flag, 1]))
    },
    [flags, removeFilter, setFilter]
  )
}
